import React from 'react';
import TableSearch from "@/components/table/tableSearch";
import {useApiSearchAdminSmsHistory} from "@/api/settings";
import toFaNumber from "@/lib/utils/number";
import {Input} from "antd";
import {convertToJalaliWithFormat} from "@/lib/utils/date";
import {URLS} from "@/lib/urls";
import AdminLayout from "@/components/layout/admin/adminLayout";

function SmsHistoryPage(props) {
    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            render: function (text, record) {
                return (<div>

                    <code>{text}</code>
                    <br/>
                    <span>{record?.provider}</span>
                </div>)
            }
        },
        {
            title: 'موبایل',
            dataIndex: 'mobile',
            key: 'mobile',
            render: function (text, record) {
                return toFaNumber(text)
            }
        },
        {
            title: 'متن پیام',
            dataIndex: 'message',
            key: 'message',
            render: function (text, record) {
                return (text)
            }
        },

        {
            title: 'تاریخ',
            dataIndex: 'created_at',
            key: 'created_at',
            responsive: ['md'],
            render: (text) => convertToJalaliWithFormat(text, 'jYYYY/jMM/jDD HH:mm:ss')
        },
        {
            title: 'نتیجه',
            dataIndex: 'result',
            key: 'result',
            render: (text, record) => {
                return (<>
                    <Input.TextArea dir={'ltr'} className={'w-full'} rows={5} readOnly={true}>{text}</Input.TextArea>
                    {/*<pre>{text}</pre>*/}
                </>)

            }
        },

    ]

    return (
        <AdminLayout pageTitle={'سوابق ارسال پیامک'} backTo={URLS.admin.setting.dashboard}>

            <div>

                <TableSearch searchInput={true} apiFn={useApiSearchAdminSmsHistory} columns={columns}/>
            </div>
        </AdminLayout>
    );
}

export default SmsHistoryPage;